import React from "react"
import { useRecoilValue } from "recoil"
import { currentPatientFileInfoAtom } from "../../../../Pages/Data/Visualize/DataReview/Atoms/PatientFile"
import { DataSource } from "../../../../Pages/Data/Visualize/DataReview/Types/DataSource"
import { MobergColumn, MobergFontFamily } from "../../../../Moberg"

export const SourceDataOriginSummary: React.FC = () => {
	const { sources } = useRecoilValue(currentPatientFileInfoAtom)
	const hasAssociatedCns = sources.has(DataSource.ASSOCIATED_OFFLINE_DSA)
	const availabilityMessage = hasAssociatedCns
		? "Blue dots mark modalities available from the associated CNS archive"
		: "Blue dots mark modalities available in the selected patient file"

	return (
		<MobergColumn gap="8px">
			<div
				style={{
					display: "inline-flex",
					alignItems: "center",
					alignSelf: "flex-start",
					color: "var(--text-secondary-color)",
					fontFamily: MobergFontFamily.REGULAR,
					fontSize: 12,
					background: "var(--color-hover-neutral)",
					borderRadius: 4,
					padding: "6px 10px",
				}}
			>
				<span
					style={{
						display: "inline-block",
						width: 8,
						height: 8,
						borderRadius: "50%",
						background: "var(--color-accent-interactive)",
						marginRight: 8,
						flexShrink: 0,
					}}
				/>
				<span>{availabilityMessage}</span>
			</div>
		</MobergColumn>
	)
}
